import { useCallback, useMemo, useState } from 'react';
import { throttle } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import { ENTER as ENTER_KEY_CODE } from 'UIComponents/constants/KeyCodes';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { getContentTypeId, getModalLangKey } from 'ContentEditorUI/utils/contentManagementPanel/contentTableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getCloneNameFromName = originalName => unescapedText('contentManagementPanel.modals.shared.clone.cloneName', {
  originalName
});
const CloneContentModal = ({
  closeModal,
  content,
  cloneContent
}) => {
  const [cloneName, setCloneName] = useState(getCloneNameFromName(content.name));
  const [loading, setLoading] = useState(false);
  const contentTypeId = getContentTypeId(content);
  const handleCloneContent = useCallback(() => {
    setLoading(true);
    cloneContent(content, cloneName);
  }, [cloneContent, content, cloneName]);
  const handleCloneContentThrottled = useMemo(() => throttle(handleCloneContent, 1000), [handleCloneContent]);
  const handleKeyDown = e => {
    return e && e.keyCode === ENTER_KEY_CODE && !loading && cloneName.length > 0 ? handleCloneContentThrottled() : null;
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "clone-content-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getModalLangKey('clone.header', contentTypeId)
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeModal
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getModalLangKey('clone.inputLabel', contentTypeId)
        }),
        children: /*#__PURE__*/_jsx(UITextInput, {
          onChange: e => setCloneName(e.target.value),
          onKeyDown: handleKeyDown,
          value: cloneName
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        "data-test-id": "modal-confirm",
        disabled: cloneName.length === 0,
        loading: loading,
        onClick: handleCloneContentThrottled,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.modals.shared.clone.confirm"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "modal-cancel",
        onClick: closeModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.modals.shared.cancel"
        })
      })]
    })]
  });
};
export default CloneContentModal;